
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/il-rifugio-del-vino",
      function () {
        return require("private-next-pages/il-rifugio-del-vino.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/il-rifugio-del-vino"])
      });
    }
  